import { useMemo, useState } from 'react';
/**
 * @description
 * Error boundaries only catches errors during rendering, lifecycle methods, and constructors. It does not catch errors in event handlers, async code, SSR, and errors thrown in the error boundary itself.
 * This hook is a workaround, and can be used to pass those errors to the nearest error boundary.
 *
 * @example
 * const { showBoundary } = useErrorBoundary();
 * useEffect(() => {
 *  fetch().then(resp => {
 *    // ...
 *  }, error => showBoundary(error));
 * }, []);
 *
 * @see
 * https://legacy.reactjs.org/docs/error-boundaries.html#introducing-error-boundaries
 */
export function useErrorBoundary() {
  const [state, setState] = useState({
    error: null,
    hasError: false
  });
  const memoized = useMemo(() => ({
    showBoundary: error => setState({
      error,
      hasError: true
    })
  }), []);
  if (state.hasError) {
    throw state.error;
  }
  return memoized;
}